// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__344pz","list":"PatternAutocomplete_list__3pYFe"};